import { PROTOCOL_STEP_KEYS, type ProtocolType } from '../../services/quarantineService';

type Translate = (key: string, opts?: Record<string, unknown>) => unknown;

/** Reminder task titles of a protocol's steps, in the user's language. */
export function taskTitles(t: Translate, type: ProtocolType, name: string | null): Record<string, string> {
  return Object.fromEntries(
    PROTOCOL_STEP_KEYS[type].map((key) => [key, String(t(`quarantine.steps.${key}.task`, { name: name ?? String(t('quarantine.displayTank')) })).slice(0, 200)]),
  );
}
